// The model catalog is SERVED, not hardcoded (ADR-182 D2).
//
// This file used to carry a `MODELS` array — one of four hand-synced copies of
// the same list (here, Mission Control's fleetprofile.Models(),
// agentfleet-console's fleetprofile.Models(), and validate-repo-schema.py's
// ALLOWED_MODELS). The console's copy had already drifted: it was missing
// claude-opus-5. Four copies were survivable for one vendor; across five they
// guarantee a picker that offers a model CI rejects.
//
// The list now comes from GET /api/models, which reads the generated
// platform/model-catalog.json and adds this fleet's per-vendor credential
// status. Use `useModelCatalog()` / `<ModelPicker>` from components/ModelPicker.
//
// DEFAULT_MODEL stays as the pre-selection a form uses before the catalog
// arrives, and as the label for "inherits the platform default". It matches
// the platform's Claude Sonnet 5.5 default; prefer the served value once loaded.

/** The platform default model (fleetprofile.DefaultModel()). */
export const DEFAULT_MODEL = 'claude-sonnet-5-5'

/** The vendor that serves the platform default. */
export const DEFAULT_PROVIDER = 'anthropic'

/** A readable label for a model id when no catalog entry is at hand.
 *
 *  Returns the id itself rather than inventing a prettier name: a surface
 *  showing a model this build has never heard of should show exactly what is
 *  configured, not a guess at what it might be.
 */
export function modelLabel(id: string): string {
  return id
}
